import { useMemo, useState } from 'react'
import {
  identifyCompany,
  identifyUser,
  initMixpanel,
  registerSuperProperties,
  resetMixpanel,
  setUserProfileProperties,
  trackEvent,
} from '@/components/mixpanel/client'
import { MixpanelContext } from '@/components/mixpanel/context'
import type { MixpanelContextValue } from '@/components/mixpanel/types'

export const MixpanelProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  // Initialize once, synchronously on first render. Child effects run before
  // parent effects, so initializing in a useEffect here could let a nested
  // component call track() before the SDK is ready. initMixpanel() is guarded,
  // so StrictMode's double-invocation is a no-op.
  useState(() => {
    initMixpanel()
    return null
  })

  const value = useMemo<MixpanelContextValue>(
    () => ({
      track: trackEvent,
      identify: identifyUser,
      identifyCompany,
      register: registerSuperProperties,
      setUserProperties: setUserProfileProperties,
      reset: resetMixpanel,
    }),
    []
  )

  return (
    <MixpanelContext.Provider value={value}>
      {children}
    </MixpanelContext.Provider>
  )
}
